const setLocalUserInfo = (userInfo: any) => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem("userInfo");
  return userInfo ? JSON.parse(userInfo) : null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalTenantId = (tenantId: string) => {
  localStorage.setItem("tenantId", tenantId);
};

const getTenantId = () => {
  const tenantId = localStorage.getItem("tenantId");
  const envTenantId = import.meta.env.VITE_X_TENANTID;
  return tenantId ?? (typeof envTenantId === "string" && envTenantId ? envTenantId : null);
};
const setLocalAccessToken = (accessToken: string) => {
  localStorage.setItem("accessToken", accessToken);
};

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken ?? null;
};

const setLocalRefreshToken = (refreshToken: string) => {
  localStorage.setItem("refreshToken", refreshToken);
};

const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return refreshToken ?? null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

export {
  clearLocalStorage,
  getAccessToken, getLanguage, getRefreshToken,
  getTenantId,
  getTheme, getUserInfo,
  setLocalAccessToken, setLocalLanguage, setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme, setLocalUserInfo
};
